/* eslint-disable jsx-a11y/anchor-is-valid */
// src/components/ExploreSection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ExploreSection.css";
import valuesIcon from "../assets/icon-values.png";
import topicsIcon from "../assets/icon-topics.png";
import arrowIcon from "../assets/arrow.png";

const ExploreSection = () => {
  const navigate = useNavigate();

  return (
    <section className="explore-section">
      <div className="explore-inner">
        <h2 className="section-title">EXPLORE</h2>
        <div className="explore-card-group">
          {/* Card 1 */}
          <div
            className="explore-card"
            onClick={() => navigate("/policy-swipe")}
          >
            <img src={valuesIcon} alt="Values" className="card-icon" />
            <h3 className="card-title">
              Find politicians who share your values
            </h3>
            <p className="card-body">
              Match with representatives based on your beliefs and priorities
            </p>
            <a className="card-link">
              Start Matching <img src={arrowIcon} alt="arrow" />
            </a>
          </div>

          {/* Card 2 */}
          <div className="explore-card" onClick={() => navigate("/topics")}>
            <img src={topicsIcon} alt="Topics" className="card-icon" />
            <h3 className="card-title">Explore political topics</h3>
            <p className="card-body">
              Explore political topics and discover where leaders really stand
              on the issues you care about.
            </p>
            <a className="card-link">
              Browse Topics <img src={arrowIcon} alt="arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreSection;
